import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { navigationItems } from "../../content/site";
import { ButtonLink } from "../ui/Button";

export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
        className={`sticky top-0 z-40 transition-all duration-300 bg-white/95 backdrop-blur-md border-t-4 border-[#CEDC00] ${
          scrolled ? "border-b border-stone-200/70 shadow-sm" : "border-b border-stone-100"
        }`}
      >
        <div className="w-full px-6 py-4 lg:px-12">
          <div className="flex items-center justify-between gap-6">
            <div className="inline-flex items-center gap-4 text-[#0E1C2C]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64"
                className="h-10 w-10 shadow-sm"
                role="img"
                aria-labelledby="logo-title"
              >
                <title id="logo-title">The Education Project Logo</title>
                <rect width="64" height="64" rx="14" fill="#0293cc" />
                <path d="M17 21h30v4H34v18h-4V25H17z" fill="#FAF9F6" />
                <path d="M17 47h30" stroke="#CEDC00" stroke-width="4" stroke-linecap="round" />
              </svg>
              <span>
                <span className="block font-display text-xl text-[#0E1C2C] sm:text-2xl leading-none font-bold tracking-tight">Education Project</span>
                <span className="hidden text-[0.6875rem] tracking-wider uppercase text-stone-500 lg:block mt-1 font-semibold">
                  501(c)(3) lifelong-learning ecosystem platform
                </span>
              </span>
            </div>

            <nav className="hidden items-center gap-5 lg:flex xl:gap-8" aria-label="Primary">
              {navigationItems.map((item) => (
                <NavLink
                  key={item.href}
                  to={item.href}
                  end={item.href === "/"}
                  className={({ isActive }) =>
                    `text-[0.85rem] font-bold uppercase tracking-wider transition-colors ${
                      isActive ? "text-[#0293cc] border-b-2 border-[#0293cc] pb-1" : "text-[#0E1C2C] hover:text-[#0293cc] pb-1"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <ButtonLink to="/donate" variant="primary" className="!py-2 !px-5 text-sm uppercase tracking-wider">
                Donate
              </ButtonLink>
            </nav>

            <button
              type="button"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-stone-200 bg-white text-[#0E1C2C] lg:hidden hover:bg-stone-50 transition-colors"
              onClick={() => setMenuOpen((open) => !open)}
              aria-expanded={menuOpen}
              aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
            >
              {menuOpen ? <XMarkIcon className="h-6 w-6" /> : <Bars3Icon className="h-6 w-6" />}
            </button>
          </div>

          {menuOpen ? (
            <nav className="mt-4 border-t border-stone-200/70 py-4 lg:hidden animate-fade-in" aria-label="Mobile">
              <div className="flex flex-col gap-2">
                {navigationItems.map((item) => (
                  <NavLink
                    key={item.href}
                    to={item.href}
                    end={item.href === "/"}
                    onClick={() => setMenuOpen(false)}
                    className={({ isActive }) =>
                      `rounded-full px-5 py-3 text-[0.95rem] font-bold uppercase tracking-wider transition-colors ${
                        isActive ? "bg-[#0293cc]/10 text-[#0293cc]" : "text-[#0E1C2C] hover:bg-stone-50"
                      }`
                    }
                  >
                    {item.label}
                  </NavLink>
                ))}
                <div className="mt-4 px-2">
                  <ButtonLink to="/donate" variant="primary" className="w-full justify-center text-sm uppercase tracking-wider" onClick={() => setMenuOpen(false)}>
                    Support the Mission
                  </ButtonLink>
                </div>
              </div>
            </nav>
          ) : null}
        </div>
      </header>
  );
};
